<template>
  <div class="big-number">
    <el-tooltip
      class="item"
      effect="dark"
      :content="''+ BIGNUM.toSmallNum(number||0)"
      placement="top"
    >
      <span>{{ showNumber }}</span>
    </el-tooltip>
  </div>
</template>

<script>
import * as BIGNUM from '@/utils/bigNumberTran.js'
export default {
  props: {
    number: {
      type: [Number, String, Object],
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      BIGNUM: BIGNUM
    }
  },
  computed: {
    showNumber() {
      return this.BIGNUM.fixed(this.BIGNUM.toSmallNum(this.number || 0))
    }

  },
  watch: {},
  created() {},
  methods: {
  }
}
</script>
<style scoped lang="scss">
.big-number{
  display: inline-block;
}
</style>
